export default __webpack_public_path__ + "static/media/html.f61e377f.png";